// Поиск виджета

export function deepSearchWidget(widgets, searchWidgetId) {
  if (!widgets) {
    return
  }
  let foundWidget = undefined
  for (let index in widgets) {
    if (widgets[index]['$ID'] === searchWidgetId) {
      return widgets[index]
    }

    let containerName = getWidgetContainerName(widgets[index])
    if (widgets[index]?.[containerName]?.length) {
      foundWidget =  deepSearchWidget(widgets[index][containerName], searchWidgetId)
    }

    if (foundWidget) {
      return foundWidget
    }
  }
}

export function getWidgetContainerName(widget) {
  let containerName = 'Widgets'
  switch (widget?.$Type) {
    case 'dr-grid-layout':
      containerName = 'Rows'
      break
    case 'dr-grid-layout-row':
      containerName = 'Columns'
      break
    case 'dr-tabs':
      containerName = 'Tabs'
      break
    case 'dr-expansion-panel':
      containerName = 'PanelItems'
      break
    default:
      break
  }
  return containerName
}